import React from 'react';
import { useSelectCurrentOrder } from '../../selectors/order/selectCurrentOrder';
import { useParams } from 'react-router-dom';
import { UUID } from '../../types/shared/UUID';
import { CdBuilderSection } from './CdBuilder';
import { CDBuilderApplicationProvider } from './context/ApplicationProvider';
import { CdBuilderContainer } from './CdBuilderContainer';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';

export const CDBuilderPage: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const { orderId, section } = useParams<{ orderId: UUID; section?: CdBuilderSection }>();
  return (
    <CDBuilderApplicationProvider order={data}>
      <CdBuilderContainer
        ownerId={orderId}
        section={section || 'section-a-j'}
        pdfRedirectUrl={clientUrls.urlFor.documentsIndex(orderId)}
      />
    </CDBuilderApplicationProvider>
  );
};
